import { useDispatch, useSelector } from "react-redux";
import AddPosition from "./AddPosition"
import { useEffect, useState } from "react";
import { getTitle } from "Store/Organization/Title/TitleAction";

const ApprovalDashboardContainer = (props: any) => {
    const {
        setSelectedAddtitle,
        selectedAddTitle,
        setSelectedAddPosition,
        selectedAddPosition,
        hierarchyTableTemp,
        additionalApprovalTableTemp,
        isAdditionalApprover,
        setAddPositionError,
        addPositionError,
        setAddTitleError,
        addtitleError,
        isEditPosition
    } = props
    const [titleDropDownListTemp, setTitleDropDownListTemp] = useState<any>();
    const dispatch = useDispatch();
    const {
        titleDropDownList
    }: any = useSelector((state?: any) => ({
        titleDropDownList: state.titleReducer.titleDropDownList,
    }));
    useEffect(() => {
        dispatch(getTitle())
        setAddPositionError('')
        setAddTitleError('')
    }, [])

    const positionOptions = [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' },
    ]

    useEffect(() => {
        ///Modified dropDown values as required
        let titleDropDownListValue = titleDropDownList?.map((item: any) =>
            ({ value: item.value, label: item.text, key: item.value })
        );
        setTitleDropDownListTemp(titleDropDownListValue)
    }, [titleDropDownList])

    const onPositionChange = (e: any) => {
        let data = isAdditionalApprover ? additionalApprovalTableTemp : hierarchyTableTemp
        if (parseInt(e?.label) > parseInt(data?.current?.length + 1)) {
            setAddPositionError(`Please select within ${data?.current?.length + 1} position `)
            setSelectedAddPosition('')
        } else {
            setAddPositionError('')
            setSelectedAddPosition(e)
        }

    }

    const onTitleChange = (e: any) => {
        let data = isAdditionalApprover ? additionalApprovalTableTemp : hierarchyTableTemp
        let tableTemp = data.current ? JSON.parse(JSON.stringify(data.current)) : []
        let isAlreadyExist: any = {}
        let isExistInSamePosition: any = {}
        if (isEditPosition) {
            isAlreadyExist = tableTemp?.find((itemVal: any) => itemVal?.title == e?.label)
            isExistInSamePosition = tableTemp?.find((itemVal: any) => (itemVal?.title == e?.label && itemVal?.stepNumber == selectedAddPosition?.value))
        } else {
            isAlreadyExist = tableTemp?.find((itemVal: any) => itemVal?.title == e?.label)
        }
        if (isExistInSamePosition?.hasOwnProperty('stepNumber')) {
            setAddTitleError(`${e?.label} is exists in same position ${selectedAddPosition?.value}`)
        } else if (isAlreadyExist?.hasOwnProperty('stepNumber')) {
            setAddTitleError(`${e?.label} is already exists in position ${isAlreadyExist?.stepNumber}`)
        } else {
            setAddTitleError('')
        }
        setSelectedAddtitle(e)
    }

    return (
        <AddPosition
            titleDropDownListTemp={titleDropDownListTemp}
            positionOptions={positionOptions}
            selectedAddTitle={selectedAddTitle}
            selectedAddPosition={selectedAddPosition}
            onPositionChange={onPositionChange}
            onTitleChange={onTitleChange}
            addPositionError={addPositionError}
            addtitleError={addtitleError}
            isEditPosition={isEditPosition} />
    )
}

export default ApprovalDashboardContainer